import React from 'react';
import { Phone, AlertCircle, MessageSquare } from 'lucide-react';

const EmergencyBanner = () => {
  return (
    <div className="bg-red-600 text-white py-3 px-4 fixed top-0 left-0 right-0 z-50 shadow-lg" data-testid="emergency-banner">
      <div className="overflow-hidden">
        <div className="animate-marquee hover:pause flex items-center justify-center gap-8 whitespace-nowrap">
          {/* Emergency 911 */}
          <div className="flex items-center gap-2 font-bold text-base md:text-lg">
            <AlertCircle className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" />
            <span className="font-black">EMERGENCY:</span>
            <a 
              href="tel:911" 
              className="hover:underline font-black text-yellow-300 hover:text-yellow-100 transition-colors"
              aria-label="Call 911 for emergency"
            >
              Call 911
            </a>
          </div>

          <span className="text-white/50">|</span>

          {/* Crisis Support 988 */}
          <div className="flex items-center gap-2 font-bold text-base md:text-lg">
            <Phone className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" />
            <span className="font-semibold">Crisis Support 24/7:</span>
            <a 
              href="tel:988" 
              className="hover:underline font-bold hover:text-yellow-300 transition-colors"
              aria-label="Call 988 for crisis support"
            >
              Call 988
            </a>
            <span>or</span>
            <a 
              href="sms:988" 
              className="hover:underline font-bold hover:text-yellow-300 transition-colors flex items-center gap-1"
              aria-label="Text 988 for crisis support"
            >
              <MessageSquare className="w-4 h-4" />
              Text 988
            </a>
          </div>

          {/* Duplicate for seamless loop */}
          <span className="text-white/50">|</span>

          {/* Emergency 911 - Duplicate */}
          <div className="flex items-center gap-2 font-bold text-base md:text-lg">
            <AlertCircle className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" />
            <span className="font-black">EMERGENCY:</span>
            <a 
              href="tel:911" 
              className="hover:underline font-black text-yellow-300 hover:text-yellow-100 transition-colors"
              aria-label="Call 911 for emergency"
            >
              Call 911
            </a>
          </div>

          <span className="text-white/50">|</span>

          {/* Crisis Support 988 - Duplicate */}
          <div className="flex items-center gap-2 font-bold text-base md:text-lg">
            <Phone className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" />
            <span className="font-semibold">Crisis Support 24/7:</span>
            <a 
              href="tel:988" 
              className="hover:underline font-bold hover:text-yellow-300 transition-colors"
              aria-label="Call 988 for crisis support"
            >
              Call 988
            </a>
            <span>or</span>
            <a 
              href="sms:988" 
              className="hover:underline font-bold hover:text-yellow-300 transition-colors flex items-center gap-1"
              aria-label="Text 988 for crisis support"
            >
              <MessageSquare className="w-4 h-4" />
              Text 988
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyBanner;